var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 13.45 3.25 17.15 7.5 17.9L7.55017 17.8599C7.53344 17.8566 7.51672 17.8533 7.5 17.85V11.5H5.25V9H7.5V7C7.5 4.75 8.95 3.5 11 3.5C11.65 3.5 12.35 3.6 13 3.7V6H11.85C10.75 6 10.5 6.55 10.5 7.25V9H12.9L12.5 11.5H10.5V17.85C10.4833 17.8533 10.4666 17.8566 10.4498 17.8599L10.5 17.9C14.75 17.15 18 13.45 18 9C18 4.05 13.95 0 9 0C4.05 0 0 4.05 0 9Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.95a28a8031f8e166676e9fa39b14bb38.svg";
export { ForwardRef as ReactComponent };